
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { LoginForm } from "@/components/AreaPaciente/LoginForm";
import { HeroSection } from "@/components/AreaPaciente/HeroSection";
import { ContactSection } from "@/components/AreaPaciente/ContactSection";
import { ReactNode } from "react";

interface AreaPacienteLayoutProps {
  children?: ReactNode;
  isAdminPanel: boolean;
  showLoginForm?: boolean;
  loginFormProps?: {
    email: string;
    setEmail: (email: string) => void;
    password: string;
    setPassword: (password: string) => void;
    isLoading: boolean;
    onSubmit: (e: React.FormEvent) => void;
  };
}

export function AreaPacienteLayout({ 
  children, 
  isAdminPanel, 
  showLoginForm = false,
  loginFormProps 
}: AreaPacienteLayoutProps) {
  if (children) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <HeroSection isAdminPanel={isAdminPanel} />
      
      {showLoginForm && loginFormProps && (
        <section className="py-16">
          <div className="container mx-auto px-6">
            <LoginForm {...loginFormProps} />
            
            {!isAdminPanel && (
              <div className="text-center mt-4">
                <p className="text-sm text-gray-600">
                  Ainda não tem uma conta? Entre em contato conosco para criar sua conta.
                </p>
              </div>
            )}
          </div>
        </section>
      )}

      {!isAdminPanel && <ContactSection />}
      
      <Footer />
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
}
